
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import Deptlist from '@/components/Department/index.vue'; // 多级部门显示
import { parseTime } from '@/utils';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import TemplateAddedProgress from '@/views/template/TemplateAddedProgress.vue';

@Component({
  name: 'DeptDialog',
  components: {
    Deptlist,
    TemplateAddedProgress
  }
})
export default class extends Vue {
  @Prop({
    type: Number,
    default: 1
  })
  deptType!: Number;
  // 1 选择报修部门 2 推单选择部门
  @Prop({
    type: Number,
    default: 9
  })
  type!: Number;
  @Prop({
    type: Boolean,
    default: false
  })
  isCheckbox?: Boolean;

  @Prop({
    type: String,
    default: '0'
  })
  customerCompanyId!: string;
  @Prop({
    type: String,
    default: '0'
  })
  companyId!: string;
  @Prop({
    type: Array
  })
  selectDept!: [];
   @Prop({
     type: String,
     default: '0'
   })
  isCheck!: string;

  private listQuery = {
    deptmentName: '',
    area: [],
    page: 1
  };
  private listData = [];
  private tableDataLower2 = []
  private tableDataLower3 = []
  private tableDataLower4 = []
  private tableDataLower5 = []
  private tableDataLower6 = []
  private tableDataLower7 = []
  private tableDataLower8 = []

  private expands: any = []
  private expands2: any = []
  private expands3: any = []
  private expands4: any = []
  private expands5: any = []
  private expands6: any = []
  private expands7: any = []
  private expands8: any = []

  private loading = false;
  private moreLoading = false;
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private selection = '';
  private checkboxSelected:any = []
  private checkboxSelectedId:any = []
  private lAreaData!: any;

  private isSearchDept = false
  private columnItemData: any = [
    { name: '部门名称', value: '0', checked: true },
    { name: '添加时间', value: '1', checked: false },
    { name: '省市区', value: '2', checked: true }
  ]
  private sourceType:any= -1
  private radioSelected='';

  created() {
    if (this.selectDept) {
      this.checkboxSelected = this.selectDept;
      this.checkboxSelected.forEach((element:any) => {
        if (element.dept_id) {
          this.checkboxSelectedId.push(element.dept_id);
        } else {
          this.checkboxSelectedId.push(element.id);
        }
      });
    }

    switch (this.deptType) {
      case 1:
        if (checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_REPORT_DEPT)) {
          this.sourceType = 1;
          this.getDepartmentList(0, 1);
        } else {
          this.listData = UserModule.getUserDeptList;
        }
        break;
      case 2:

        this.getDepartmentList(0, 1);
        break;
    }
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item &&
          item.child &&
          item.child.map((temp: any) => {
            if (temp && temp.child && temp.child.length === 0) {
              (temp.child as any) = undefined;
            }
          });
      }
    });
  }

  private getRowKey(row: any) {
    return row.id;
  }

  // private checkAllCustomer = false;
  // private isIndeterminateCustomer: any = null;

  // private checkAllCustomerChange(val: boolean) {
  //   // this.dealData(val, this.customerIdCheckedSelected, this.customerTableData, 0);
  //   this.isIndeterminateCustomer = false;
  //   this.$emit('checkedCustomerChange', this.checkboxSelected);
  // }
  private closeDeptHandle(item: any, index:number) {
    this.checkboxSelected.splice(index, 1);
    this.checkboxSelectedId.splice(index, 1);
  }
  private checkedSelectedChange(val:any, item:any) {
    if (val) {
      this.checkboxSelected.push(item);
    } else {
      let indexa = -1;
      for (let index = 0; index < this.checkboxSelected.length; index++) {
        const element = this.checkboxSelected[index];
        if (element.dept_id === item.dept_id || element.id === item.dept_id) {
          indexa = index;
          break;
        }
      }
      this.checkboxSelected.splice(indexa, 1);
    }
    this.$emit('changeDeptChange', this.checkboxSelected);
  }

  private getDepartmentList(deptPid:any, lev:number) {
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: this.listQuery.page,
      size: 10,
      is_multi_level: 1,
      dept_pid: deptPid
    };
    if (this.sourceType > 0) {
      params.source_type = this.sourceType;
    }
    if (parseInt(this.isCheck) === 1) {
      params.is_show_check_group_id = 1
    }
    let tableContainer = 'tableDataLower' + lev;
    let expandsContainer = 'expands' + (lev - 1);
    if (lev > 1) {
      params.page = 1;
      params.size = 9999;
      this.$data[tableContainer] = [];
    }
    if (lev === 1) {
      this.loading = true;
    }
    getDepartmentList(params)
      .then(res => {
        switch (lev) {
          case 1:
            this.loading = false;
            if (res.data) {
              if (this.listQuery.page >= res.data.page_count) {
                this.moreLoading = false;
              } else {
                this.moreLoading = true;
              }
              if (this.listQuery.page === 1) {
                this.listData = res.data.list;
              } else {
                this.listData = this.listData.concat(res.data.list);
              }
              this.paseData(this.listData);
            } else {
              this.listData = [];
            }
            break;
          case 2:
            if (res.data) {
              this.tableDataLower2 = res.data.list;
              this.paseData(this.tableDataLower2);
            } else {
              this.tableDataLower2 = [];
            }
            break;
          case 3:
            if (res.data) {
              this.tableDataLower3 = res.data.list;
              this.paseData(this.tableDataLower3);
            } else {
              this.tableDataLower3 = [];
            }
            break;
          case 4:
            if (res.data) {
              this.tableDataLower4 = res.data.list;
              this.paseData(this.tableDataLower4);
            } else {
              this.tableDataLower4 = [];
            }
            break;
          case 5:
            if (res.data) {
              this.tableDataLower5 = res.data.list;
              this.paseData(this.tableDataLower5);
            } else {
              this.tableDataLower5 = [];
            }
            break;
          case 6:
            if (res.data) {
              this.tableDataLower6 = res.data.list;
              this.paseData(this.tableDataLower6);
            } else {
              this.tableDataLower6 = [];
            }
            break;
          case 7:
            if (res.data) {
              this.tableDataLower7 = res.data.list;
              this.paseData(this.tableDataLower7);
            } else {
              this.tableDataLower7 = [];
            }
            break;
          case 8:
            if (res.data) {
              this.tableDataLower8 = res.data.list;
              this.paseData(this.tableDataLower8);
            } else {
              this.tableDataLower8 = [];
            }
            break;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });

    if (lev === 2) {
      if (this.expands.includes(deptPid)) {
        this.expands = this.expands.filter((val: any) => val !== deptPid);
      } else {
        if (this.expands.length !== 0) {
          this.expands.splice(0, this.expands.length);
          this.expands.push(deptPid);
        } else {
          this.expands.push(deptPid);
        }
      }
    } else if (lev === 3 || lev === 4 || lev === 5 || lev === 6 || lev === 7 || lev === 8) {
      if (this.$data[expandsContainer].includes(deptPid)) {
        this.$data[expandsContainer] = this.$data[expandsContainer].filter((val: any) => val !== deptPid);
      } else {
        if (this.$data[expandsContainer].length !== 0) {
          this.$data[expandsContainer].splice(0, this.$data[expandsContainer].length);
          this.$data[expandsContainer].push(deptPid);
        } else {
          this.$data[expandsContainer].push(deptPid);
        }
      }
    }
  }
  private getDepartmentListAll() {
    this.loading = true;
    const params:any = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: this.listQuery.page,
      size: 10,
      dept_pid: 0,
      is_full_path_pnames: 1
    };
    if (this.listQuery.deptmentName) {
      params.name = this.listQuery.deptmentName;
    }
    if (this.listQuery.area) {
      params.address = this.listQuery.area;
    }
    if (parseInt(this.isCheck) === 1) {
      params.is_show_check_group_id = 1
    }
    getDepartmentList(params)
      .then(res => {
        this.loading = false;
        if (res.data) {
          if (this.listQuery.page >= res.data.page_count) {
            this.moreLoading = false;
          } else {
            this.moreLoading = true;
          }
          if (this.listQuery.page === 1) {
            this.listData = res.data.list;
          } else {
            this.listData = this.listData.concat(res.data.list);
          }
          this.paseData(this.listData);
        } else {
          this.listData = []
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private paseData(val:any) {
    for (let i = 0; i < val.length; i++) {
      let cont:any = val[i];
      cont.area = val[i].province_name + val[i].city_name + val[i].district_name;
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(val, cont, i);
    }
  }
  // 展开行操作
  private expandChange(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 2);
  }
  private expandChange2(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 3);
  }
  private expandChange3(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 4);
  }
  private expandChange4(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 5);
  }
  private expandChange5(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 6);
  }
  private expandChange6(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 7);
  }
  private expandChange7(row: any, expandedRows : any) {
    this.getDepartmentList(row.id, 8);
  }
  private setCheckBoxSelect(list:any) {
    if (this.selectDept && this.selectDept.length > 0) {
      for (let index = 0; index < this.selectDept.length; index++) {
        const element:any = this.selectDept[index];
        for (let i = 0; i < list.length; i++) {
          const item:any = list[i];
          if (element.department_id === item.id) {
            this.checkboxSelected.push(list[i]);
          }
        }
      }
    }
  }
  resetData() {
    this.isSearchDept = false;
    this.selection = '';
    this.listQuery.page = 1;
    this.listQuery.deptmentName = '';
    this.listQuery.area = [];
    this.getDepartmentList(0, 1);
  }
  search() {
    this.listQuery.page = 1;
    this.isSearchDept = true;
    this.getDepartmentListAll();
  }

  moreData() {
    this.listQuery.page++;
    if (this.isSearchDept) {
      this.getDepartmentListAll();
    } else {
      this.getDepartmentList(0, 1);
    }
  }

  submit() {
    switch (this.deptType) {
      case 1:
        this.$emit('selectDeptLev', this.radioSelected);
        break;
    }
  }
}
